import React, { useState } from 'react';
import useSignOut from '@hooks/useSignOut';
import { useSelector } from 'react-redux';
import ProfilePic from '@images/profilePic.png';
import { ArrowUpPopUpIcon, SignOutIcon } from "@util/svgicon";

const TestDriveHeader = () => {
    const { signOutHandler } = useSignOut();
    const [signOutPopup, setSignOutPopup] = useState(false);
    const user = useSelector((state) => state.setUserDetails.user)
    const Bucket_url = process.env.NEXT_PUBLIC_DELIEVERY_CONTENT_URL
    const ProfilePicture = user?.avatar_url ? `${Bucket_url}${user?.avatar_url}` : ProfilePic;

    const signOutPopUpHandler = () => {
        setSignOutPopup(!signOutPopup)
    }

    return (
        <div className="testdrive_profile_container">
            <div className="testdrive-username-container">
                <p className="testdrive-username-letter" onClick={signOutPopUpHandler}>
                    Welcome, @{user?.username}
                </p>
                <img
                    src={ProfilePicture}
                    alt="UserProfile"
                    style={{ borderRadius: "50%", width: "20px", height: "20px" }}
                    onClick={signOutPopUpHandler}
                />
                <button onClick={signOutPopUpHandler}>
                    <div className={`${signOutPopup ? '[rotate:0deg]' : '[rotate:180deg]'}`}>
                        <ArrowUpPopUpIcon />
                    </div>
                </button>
                {
                    signOutPopup && (
                        <div className="absolute top-[58px] right-[24px] flex w-[400px] flex-col items-start rounded-[8px] border-[1px] border-solid border-[#DEDEDE] [box-shadow:0px_2px_4px_0px_rgba(0,_0,_0,_0.40)]">
                            <div className="w-full flex px-[16px] py-[12px] items-center bg-[#FFF]">
                                <p className="text-[#727272] text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]">More options</p>
                            </div>
                            <button className='w-full flex p-[16px] items-center gap-[10px] bg-[#FFF] rounded-b-[8px]' onClick={signOutHandler}>
                                <div className='flex p-[4px] items-center gap-[10px] rounded-[8px]'>
                                    <SignOutIcon />
                                </div>
                                <div className='flex flex-col items-start gap-[4px]'>
                                    <p className='text-[#EA0045] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]'>Sign out</p>
                                    <p className='text-[#727272] text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Logs you out of the FrodoBots system.</p>
                                </div>
                            </button>
                        </div>
                    )
                }
            </div>
        </div>
    )
}

export default TestDriveHeader